import React from "react";

const Label: React.FC<React.InputHTMLAttributes<HTMLLabelElement>> = ({className, ...props}) => 
    <label className={`text-sm text-gray-900 font-medium ${className}`} {...props} />

export default Label;